import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

//Extras
import { secondary } from '../../assets/coach-assets/constants/colors'
import { onAuthStateChanged } from 'firebase/auth'
import { auth, db } from '../../assets/connections'
import { doc, getDoc } from 'firebase/firestore'

const CoachIndex = () => {

    document.title = "Coach Dashboard"

    const navigate = useNavigate()

    //Funcion que valida si hay una sesion iniciada usando onAuthStateChanged
    const checkAuthStatus = () => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // Usuario está autenticado, obtener sus datos
                const correo = user.email
                if (correo) {
                    getData(correo)
                } else {
                    localStorage.removeItem("authTokenCoach")
                    navigate("/coach/login")
                }
            } else {
                // Usuario no autenticado, redirigir al login
                localStorage.removeItem("authTokenCoach")
                navigate("/coach/login")
            }
        }, (error) => {
            console.log("Auth state error:", error)
            localStorage.removeItem("authTokenCoach")
            navigate("/coach/login")
        })

        return unsubscribe
    }

    //Opcion que obtiene los datos del usuario logeado
    const getData = async (correo) => {
        try {
            await getDoc(doc(db, "Profesores", correo)).then(r => {
                if (r.exists()) {
                    navigate("/coach/home", {
                        state: {
                            academias: r.data().academia_profesor,
                            correo,
                            nombre_profesor: r.data().nombre_profesor + " " + r.data().apellido_p_profesor
                        }
                    })
                } else {
                    localStorage.removeItem("authTokenCoach")
                    navigate("/coach/login")
                }
            }).catch(e => {
                console.log("Error getting professor data:", e.code + " " + e.message)
                localStorage.removeItem("authTokenCoach")
                navigate("/coach/login")
            })
        } catch (e) {
            console.log("Exception getting professor data:", e)
            localStorage.removeItem("authTokenCoach")
            navigate("/coach/login")
        }
    }

    useEffect(() => {
        // Timeout de seguridad para evitar quedarse en carga indefinidamente
        const safetyTimeout = setTimeout(() => {
            const currentPath = window.location.pathname
            if (currentPath === "/coach") {
                // Si después de 5 segundos aún estamos en /coach, redirigir al login
                localStorage.removeItem("authTokenCoach")
                navigate("/coach/login")
            }
        }, 5000)

        // Subscribirse al estado de autenticación de Firebase
        const unsubscribe = checkAuthStatus()

        return () => {
            clearTimeout(safetyTimeout)
            unsubscribe()
        }
    }, [])

    return (
        <div style={{
            flex: 1,
            backgroundColor: secondary,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            height: "100vh" // para simular flex:1
        }}>
            <img
                src={require("../../assets/coach-assets/images/auxicon.png")}
                alt="auxicon"
                style={{
                    width: 200,
                    height: 200
                }}
            />
            <p style={{
                position: "absolute",
                bottom: 0,
                marginBottom: 15,
                color: "gray"
            }}>
                V4 (0.1.3)
            </p>
        </div>
    )
}

export default CoachIndex